import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18",
  "aria-hidden": "true"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M8.333 13.806V9.372l-4-2.249v4.434l4 2.249Zm1.334 0 4-2.25V7.124l-4 2.25v4.433ZM9 15.666l-6-3.349V5.683l6-3.35 6 3.35v6.634l-6 3.35Zm2.667-8.915 1.283-.712L9 3.822l-1.3.728 3.967 2.2ZM9 8.256l1.3-.728L6.35 5.31l-1.3.728L9 8.256Z"
    }, null, -1)
  ])))
}
export default { render: render }